"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentActionRequiredFilter = void 0;
var AssessmentActionRequiredFilter;
(function (AssessmentActionRequiredFilter) {
    AssessmentActionRequiredFilter["ALL"] = "ALL";
    AssessmentActionRequiredFilter["YES"] = "YES";
    AssessmentActionRequiredFilter["NO"] = "NO";
})(AssessmentActionRequiredFilter = exports.AssessmentActionRequiredFilter || (exports.AssessmentActionRequiredFilter = {}));
//# sourceMappingURL=actionRequiredFilter.js.map